import React, { Component } from 'react'
import './css/form.css'

export class connect extends Component {
  componentDidMount () {
    const script = document.createElement('script')

    script.src = 'https://embed.typeform.com/embed.js'
    script.async = true

    document.body.appendChild(script)
  }

  render () {
    return (
      <iframe id='typeform-full' title='myform' width='100%' height='100%' frameborder='0' allow='camera; microphone; autoplay; encrypted-media;' src='https://form.typeform.com/to/AWVVL8yU' />
    )
  }
}

export default connect
